import MessengerComponent from './Messenger';
import axios from 'axios';
import _ from 'lodash';
import VueNoty from 'vuejs-noty';
import Proto from './messenger-prototype';

Vue.use(VueNoty, { theme: 'bootstrap-v4', visibilityControl: false });

const Messenger = {
    options: {
        componentName: 'messenger',
    },
    install(Vue, options) {
        const _this = this;
        this.options = _.defaultsDeep(options || {}, this.options);

        if (!('axios' in window)) {
            window.axios = axios;
        }

        if (!('Bus' in window)) {
            window.Bus = new Vue();
        }

        Vue.prototype.$messenger = Proto;

        window.axios.interceptors.response.use(
            function (response) {
                _this.emitErrors({});
                _this.emitMessages(_.get(response, 'data.meta.messenger_messages', []));
                return response;
            },
            (error) => {
                _this.emitErrors(_.get(error, 'response.data.errors', {}));
                _this.emitMessages(_.get(error.response, 'data.meta.messenger_messages', []));
                return Promise.reject(error);
            },
        );

        Vue.component(this.options.componentName, MessengerComponent);
    },
    emitErrors(errors) {
        window.Bus.$emit('newMessengerErrors', errors);
    },
    emitMessages(messages) {
        window.Bus.$emit('newMessengerMessages', messages);
    },
};

export default Messenger;
